import type React from "react";

import { NotificationsPane } from "./components/NotificationsPane";

export const NotificationsRoute: React.FC = () => {
  return (
    <>
      <NotificationsPane />
    </>
  );
};

export * from "./types";
